import request from '@/libs/request';
import vue from '../../main';

// 获取筛选的监控状态数据
export const getMonitorState = () => {
  return request({
    url: '/workorder/client/trademarkMonitor/getMonitorState',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

// 获取筛选的国家数据
export const getScreenCountry = () => {
  return request({
    url: '/workorder/client/trademarkMonitor/getScreenCountry',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

// 商标监控分页
export const getTrademarkMonitorList = (data) => {
  return request({
    url: '/workorder/client/trademarkMonitor/page',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

//商标监控详情
export const getTrademarkMonitorDetail = (params) => {
  const headers = vue.$util.getHeaders();
  const gateway = headers.type === 'admin' ? 'management' : 'client';
  return request({
    url: `/workorder/${gateway}/trademarkMonitor/detail/${params.workId}`,
    params,
    method: 'get',
    headers: {
      ...vue.$util.getHeaders(),
    },
  });
};

// 获取微信绑定二维码
export const getWxQrcode = (data) => {
  return request({
    url: '/custuser/wx/gzh/create/qrcode',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

//检测微信是否绑定
export const checkWxBind = () => {
  return request({
    url: '/custuser/client/user/getCustUserWxClientFollowByUserId',
    method: 'get',
  });
};
//检测微信是否绑定中台
export const checkWxBindAdmin = (userId) => {
  return request({
    url: '/custuser/feign/getCustUserWxClientFollowByUserId/' + userId,
    method: 'get',
    headers: {
      ...vue.$util.getHeaders(),
    },
  });
};

//修改通知的邮箱
export const editTrademarkMonitorEmail = (params) => {
  const headers = vue.$util.getHeaders();
  const gateway = headers.type === 'admin' ? 'management' : 'client';
  return request({
    url: `/workorder/${gateway}/trademarkMonitor/editEmail/${params.workId}/${params.email}`,
    params,
    method: 'get',
    headers: {
      ...vue.$util.getHeaders(),
    },
  });
};

//取消工单
export const cancelWorkOrder = (params) => {
  return request({
    url: `/workorder/client/trademarkMonitor/cancelWorkOrder/${params.workId}`,
    params,
    method: 'get',
  });
};

// 查询商标监控报告
export const getTrademarkMonitorReport = (data) => {
  return request({
    url: '/workorder/client/trademarkMonitor/report',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

// 编辑恶意商标
export const editEvilTrademark = (data) => {
  const headers = vue.$util.getHeaders();
  const gateway = headers.type === 'admin' ? 'management' : 'client';
  return request({
    url: `/workorder/${gateway}/trademarkMonitor/evil/batch/edit`,
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...vue.$util.getHeaders(),
    },
  });
};

//取消订单
export const cancelOrder = (data) => {
  const headers = vue.$util.getHeaders();
  const gateway = headers.type === 'admin' ? 'management' : 'client';
  return request({
    url: `/workorder/${gateway}/trademarkMonitor/cancelOrder/${data.periodId}`,
    // data,
    method: 'get',
    headers: {
      // 'Content-Type': 'application/json;charset=UTF-8',
      ...vue.$util.getHeaders(),
    },
  });
};

//-----------------------

/**
 * 商标详情
 */
export const getTrademarkInfo = (data) => {
  return request({
    url: '/xcloudtrademarkclient/trademark/search/utils/info',
    // url: 'https://mg-xcloud-console.cjton.com/api/xcloudtrademarkclient/trademark/search/utils/info',
    data,
    method: 'post',
  });
};

/**
 * 判断是否可创建监控
 */
export const trademarkMonitorJudgeCreate = (data) => {
  let headers = vue.$util.getHeaders();
  let url = '/workorder/client/trademarkMonitor/judgeCreate';
  if (headers.type === 'admin') {
    url = '/workorder/management/trademarkMonitor/judgeCreate';
  }
  return request({
    url: url,
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...headers,
    },
  });
};
/**
 * 判断是否可创建监控
 */
export const trademarkMonitorCreate = (data) => {
  let headers = vue.$util.getHeaders();
  let url = '/workorder/client/trademarkMonitor/create';
  if (headers.type === 'admin') {
    url = '/workorder/management/trademarkMonitor/create';
  }
  return request({
    url,
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...headers,
    },
  });
};
//通过手机号判断用户是否注册
export const customerIsExist = (params) => {
  let headers = vue.$util.getHeaders();
  return request({
    url: '/custuser/management/user/custUserDetailMobileList',
    params,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...headers,
    },
  });
};

/**
 * 获取付款链接
 */
export const trademarkMonitorGetWaitPayUrl = (data) => {
  return request({
    url: '/workorder/client/trademarkMonitor/getWaitPayUrl',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};



// WEBPACK FOOTER //
// ./src/api/trademarkRegister/trademarkMonitor.js